<template>
  <v-hover v-slot="{ hover }">
    <v-autocomplete v-model="modelValue" :items="list" :readonly="!externaledit && (IsDisabled || !edit)"
      class="q-input" :class="[BorderClass, CompactClass, BlurrClass, InputColorClass]"
      :background-color="BackgroundColor" :label="labelText" hide-details="auto" :disabled="IsDisabled"
      :single-line="singleline" :rules="rules" :color="color" :item-text="textkey" :item-value="valuekey"
      :return-object="returnobject" :multiple="multiple" :small-chips="multiple"
      :clearable="!!externaledit && !IsEmpty && clearable" flat :hoverbool="setHoverBool(hover)"
      :placeholder="placeholderText" persistent-placeholder @click:clear="$emit('clear')" @focus="setEdit"
      @blur="blurInput" @keypress="editKeyPress" @keydown="editKeyDown">
      <!--  @mouseover="setHoverBool(true)" @mouseleave="setHoverBool(false)" -->

      <!-- PREPEND SLOTS -->
      <template v-slot:prepend>
        <slot name="prepend-outer" />
      </template>

      <template v-slot:prepend-inner>
        <slot name="prepend" />
      </template>
      <!------------------->

      <!-- SELECTION TEMPLATE -->
      <template v-if="multiple" v-slot:selection="data">
        <v-chip v-if="!IsEmpty" :color="data.item.Color ? data.item.Color : (color ? color : 'primary')"
          :disabled="IsDisabled" tabindex="-1" class="ml-0"
          :style="!externaledit && !edit ? 'margin-top: 2px; margin-bottom: 2px;' : 'margin-top: 2px; margin-bottom: 2px;'"
          dark small @click="data.select">
          {{ itemText(data.item) }}
          <v-btn v-if="!IsDisabled" icon x-small tabindex="-1" style="margin-right: -10px !important;"
            @click="remove(data.item)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-chip>
        <div v-else :class="InputColor + '--text'">{{ itemText(data.item) }}</div>
      </template>

      <template v-else-if="hasSlot('selection')" v-slot:selection="data">
        <slot name="selection" :data="data" :item="data.item" />
      </template>
      <!--------------------------->

      <!-- PREPEND DROPDOWN ITEM TEMPLATE -->
      <template #prepend-item>
        <!-- 
        <slot name="prepend-item" v-if="multiple && list && list.length > 2">
          <v-list-item @click="toggleAll()" style="background-color: #f2f2f2 !important">
            <v-list-item-action>
              <v-checkbox :input-value="(modelValue && list && (list.length === modelValue.length))"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('servicesystem.common_objects.commonterms.all') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </slot>
        -->
      </template>
      <!----------------------------------->

      <!-- DROPDOWN ITEM TEMPLATE --------->
      <template v-if="hasSlot('item')" v-slot:item="data">
        <slot name="item" :item="data.item"></slot>
      </template>
      <!----------------------------------->

      <!-- APPEND DROPDOWN ITEM TEMPLATE -->
      <template #append-item>
        <slot name="append-item" />
      </template>
      <!----------------------------------->

      <!-- APPEND SLOTS -->
      <template v-slot:append>
        <v-progress-circular v-if="loading" indeterminate size="20" width="2" color="primary">
        </v-progress-circular>
        <LockedWarning v-else-if="disabled" :hover="hover" />
      </template>

      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
      <!---------------->

    </v-autocomplete>
  </v-hover>
</template>


<script>
import InputMixin from "@/helpers/Mixins/InputMixin";
import LockedWarning from "@/components/Inputs/Parts/LockedWarning.vue";

export default {
  name: "QAutocomplete",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    value: [Object, String, Number, Array, Boolean],
    color: String,
    singleline: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    emitOnlyOnBlur: Boolean,
    placeholder: [String, Object],
    rules: Array,
    list: Array,
    textkey: String,
    valuekey: String,
    returnobject: Boolean,
    multiple: Boolean,
  },
  components: {
    LockedWarning,
  },
  mixins: [InputMixin],

  data() {
    return {
      edit: false,
      newValue: this.value,
    };
  },

  setup(props, { slots }) {
    const hasSlot = name => !!slots[name]
    return { hasSlot }
  },

  mounted() { },

  methods: {
    itemText(item) {
      return this.textkey ? item[this.textkey] : item;
    },

    itemValue(item) {
      return this.valuekey && !this.returnobject ? item[this.valuekey] : item;
    },

    remove(item) {
      const samefunc = (x, y) => this.SameValue(x, y);
      const valuegetter = (z) => this.itemValue(z);
      this.newValue = this.newValue.filter(function (x) {
        return !samefunc(x, valuegetter(item));
      });
    },

    toggleAll() {
      if (this.list.length === this.modelValue.length) {
        this.modelValue = [];
      } else {
        if (this.valuekey && !this.returnobject) {
          this.modelValue = this.list.map(x => x.Id)
        } else {
          this.modelValue = Object.assign([], this.list);
        }
      }
    },
  },

  computed: {
    placeholderText() {
      return this.placeholder ? this.placeholder : this.list && this.list[0] ? "" : "N/A";
    },
  },

  watch: {},
};
</script>


<style lang="scss">
/* classes bellow fix a vuetify bug that breaks the persistant-placeholder when the input is unfocused */
.v-autocomplete:not(.v-input--is-focused).v-select--chips>>>input {
  max-height: inherit;
}

.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
  max-height: inherit;
}
</style>